import api from '@/factories/api';
import Axios from 'axios';

const vectorApi = Axios.create({
  baseURL: 'https://www.workforstudents.com/ajax/conveyour/',
  withCredentials: false,
});

const STORAGE_KEY = 'recruitReferrerInfo_threeWayEnabled';

export default {
  namespaced: true,

  state: {
    vectorOffices: [],
    vectorSnippets: [],
    threeWayInfoEnabled: false,
  },

  getters: {
    vectorOffice: (state) => {
      return (officeNumber) =>
        state.vectorOffices.find((i) => i.office_number == officeNumber);
    },
    outreachSnippets: (state) => {
      return state.vectorSnippets.filter((snippet) =>
        snippet.shortcut.includes('vmc.outreach')
      );
    },
    getSingleVectorSnippet: (state) => {
      return (shortcut) =>
        state.vectorSnippets.find((snippet) => snippet.shortcut === shortcut);
    },
    threeWayInfoEnabled: (state) => state.threeWayInfoEnabled,
    isThreeWayActive: (state) => {
      return (tags) => {
        const hasTag =
          Array.isArray(tags) &&
          tags.some((tag) => tag?.toLowerCase() === '3way');
        return state.threeWayInfoEnabled || hasTag;
      };
    },
  },

  actions: {
    async loadOfficeInfo({ getters, commit }, officeNumber) {
      const office = getters.vectorOffice(officeNumber);
      if (office) return office;

      const data = await api().get(`vector/offices`, {
        params: { office_number: officeNumber },
      });

      if (Array.isArray(data) && data.length) {
        commit('addOffice', data[0]);
        return data[0];
      }
      return {};
    },

    async loadRecruitingActivityReport(_, { timeframe } = {}) {
      const params = { data: 1 };
      if (timeframe) params.timeframe = timeframe;
      return await api().get('reports/recruitingActivitySummary', { params });
    },

    async loadRecruitInterviews(_, { recruit_id, zip_code }) {
      if (!recruit_id) return [];
      try {
        const params = {
          recruitId: recruit_id,
          zipCode: zip_code || '',
        };

        return (
          await vectorApi.get('/interviewListingSecure.do', {
            params,
          })
        )?.data;
      } catch (err) {
        throw err;
      }
    },

    async getOfficeData(_, { recruit_id }) {
      if (!recruit_id) return {};
      const officeInfo = (
        await vectorApi.get('/officeData.do', {
          params: { recruitId: recruit_id },
        })
      )?.data;
      return officeInfo || {};
    },

    async loadReferringRep(_, referringRepId) {
      return api({ baseURL: '/' }).get(
        `plugin/vmc/contacts/${referringRepId}/referring_rep`
      );
    },

    async ensureRecruit(_, { contactId }) {
      return api({ baseURL: '/' }).post(
        `plugin/vmc/contacts/ensure_recruit/${contactId}`
      );
    },

    async loadVectorSnippets({ commit, state }) {
      if (state.vectorSnippets.length) return;

      const snippets = await api({ baseURL: '/' }).get('plugin/vmc/snippets', {
        params: { shortcut_regex: 'vmc' },
      });
      commit('setVectorSnippets', snippets);
    },

    loadThreeWayInfoEnabled({ commit }) {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved !== null) {
        commit('setThreeWayInfoEnabled', saved === 'true');
      }
    },

    toggleThreeWayInfoEnabled({ commit }, enabled) {
      commit('setThreeWayInfoEnabled', enabled);
      localStorage.setItem(STORAGE_KEY, String(enabled));
    },
  },

  mutations: {
    addOffice: (state, office) => {
      state.vectorOffices.push(office);
    },
    setVectorSnippets: (state, snippets) => {
      state.vectorSnippets = snippets;
    },
    setThreeWayInfoEnabled: (state, enabled) => {
      state.threeWayInfoEnabled = enabled;
    },
  },
};
